import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { stopAllVideoPlayback } from '../utils/videoUtils';

/**
 * React hook that detects navigation events and stops all video playback
 */
export const useStopVideoOnNavigation = () => {
  const location = useLocation();
  
  useEffect(() => {
    // When location changes, stop all video playback
    stopAllVideoPlayback();
  }, [location.pathname]);
};

/**
 * Component that can be used in router to detect navigation and stop videos
 */
export const NavigationEventCatcher: React.FC = () => {
  useStopVideoOnNavigation();
  return null; // This is a utility component, doesn't render anything
};

export default useStopVideoOnNavigation;
